<template>
  <div id="app">
    <!-- <div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div> -->
    <router-view/>
	
  </div>
</template>

<style lang="scss">
@import "./assets/css/index.css";

.el-dialog__body {
    padding: 10px 10px;
    color: #606266;
    font-size: 14px;
    word-break: break-all;
}
body {
    margin: 0;
    padding: 0;
    font-size: 14px;
    -webkit-font-smoothing: antialiased;
    overflow: scroll;
    overflow-y: hidden;
}

#app {
    position: absolute;
    top: 0;
    bottom: 0;
    width: 100%;
}

.el-submenu [class^=fa] {
    vertical-align: baseline;
    margin-right: 10px;
}

.el-menu-item [class^=fa] {
    vertical-align: baseline;
    margin-right: 10px;
}

.toolbar {
    background: #f2f2f2;
    padding: 5px;
    padding-bottom: 5px !important;
    margin: 0px;
    .el-form-item {
        margin-bottom: 0px;
    }
}
.postForm {
		width: 80%;
		margin-left: 50px;
    .el-form-item {
        margin-bottom: 5px;
    }
		.title-prompt {
			font-size: 12px;
			top: 10px;
			color: #ff4949;
		}
    .formItem100{
			width: 100px;
		}
		.formItem {
			width: 250px;
		}
		.formItem150 {
			width: 150px;
		}
		.formItem200 {
			width: 200px;
		}
		.formItem300 {
			width: 300px;
		}
		.formItem450 {
			width: 450px;
		}
		.healItem {
			margin-top: 10px;
		}
		.notBlank .el-form-item__label::before{
			content: '*';
			color: #F56C6C;
			margin-right: 4px;
		}
		
	}
  .filterForm {
		width: 99%;
    .el-form-item {
        margin-bottom: 1px;
        margin-top: 0px;
    }
    .formItem100{
			width: 100px;
		}
		.formItem {
			width: 200px;
		}
		.formItem150 {
			width: 150px;
		}
		.formItem200 {
			width: 200px;
		}
    .formItem250 {
			width: 250px;
		}
		.formItem300 {
			width: 300px;
		}
		.formItem450 {
			width: 450px;
		}
		.notBlank .el-form-item__label::before{
			content: '*';
			color: #F56C6C;
			margin-right: 4px;
		}
		
	}
 .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    width: 120px;
    height: 90px;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 120px;
    height: 90px;
    line-height: 90px;
    text-align: center;
    vertical-align: middle;
    //padding-top: 30px;
    background-color: #fbfdff
  }
  .avatar  {
    width: 120px;
    height: 90px !important;
    display: block;
	  position: relative;
    padding-top:0px;
    margin-top: 0px;
  }
  .avatar img {
    max-width: 120px;
    max-height: 90px;
  }
  .avatar .close{display: none;}
  .avatar-uploader:hover .avatar .close{display: block;position: absolute;right: 0px;top: 0px;line-height: 1;font-size: 22px;color: red;}

  .el-upload--picture-card {
    width: 120px;
    height: 90px;
    line-height: 90px;
}
.el-upload-list--picture-card .el-upload-list__item {
  width: 120px;
    height: 90px;
}


  .el-button--primary {
    color: #FFF;
    background-color: #169BD5;
    border-color: #169BD5;
}
.gridButtonCls,.el-table .el-button{
  padding:5px;
}
.linkcolor{
  color:#082E54;
  text-decoration:none;
}
.el-input.is-disabled .el-input__inner {
    background-color: #F5F7FA;
    border-color: #E4E7ED;
    color: #91949b;
    cursor: not-allowed;
}

.tagStatus {
		border-radius: 5px;
		padding: 2px;
		margin-right: 2px;
		margin-bottom: 2px;
		text-align: center;
		font-size:12px;
	}

</style>


<script>
  export default {
    name: 'app',
    created () {
      /* if (localStorage.getItem('MenuData') && this.$router.options.routes.length <= 1) {
       	   alert(this.$router.options.routes.length);
       	   let routes = JSON.parse(localStorage.getItem('MenuData'))
       	   this.$router.addRoutes(routes);
       	   this.$router.options.routes.push(routes);
		   this.$router.replace("/");
       } */
    }
  }
  </script>

